import { Box, Flex } from '@chakra-ui/react';
import type { CSSProperties, ReactNode } from 'react';

interface CardProps {
  variant?: 'default' | 'elevated' | 'compact';
  accentColor?: string;
  minHeight?: number;
  style?: CSSProperties;
  children: ReactNode;
  [key: string]: unknown;
}

export function Card({ variant = 'default', accentColor, minHeight, style, children, ...rest }: CardProps) {
  return (
    <Box
      bg={variant === 'elevated' ? 'surface.elevated' : 'surface.primary'}
      border="1px solid"
      borderColor="border.secondary"
      borderRadius="lg"
      px={variant === 'compact' ? '4' : '5'}
      py={variant === 'compact' ? '3' : '5'}
      boxShadow={variant === 'elevated' ? 'sm' : 'xs'}
      borderLeft={accentColor ? `3px solid ${accentColor}` : undefined}
      minH={minHeight ? `${minHeight}px` : undefined}
      style={style}
      {...rest}
    >
      {children}
    </Box>
  );
}

export function CardHeader({ children, style }: { children: ReactNode; style?: CSSProperties }) {
  return (
    <Flex
      align="center"
      justify="space-between"
      mb="4"
      style={style}
    >
      {children}
    </Flex>
  );
}

export function CardBody({ children, style }: { children: ReactNode; style?: CSSProperties }) {
  return <Box style={style}>{children}</Box>;
}
